import * as tslib_1 from "tslib";
import * as idb from 'idb';
import * as i0 from "@angular/core";
var IdbService = /** @class */ (function () {
    function IdbService() {
        this.dbName = 'mldickes-db';
        this.dbVersion = 2;
        if (!('indexedDB' in window)) {
            throw new Error('This browser does not support IndexedDB');
        }
    }
    IdbService.prototype.idbContext = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.idb) {
                    return [2 /*return*/, this.idb];
                }
                return [2 /*return*/, idb
                        .openDB(this.dbName, this.dbVersion, {
                        upgrade: function (database, oldVersion, newVersion, transaction) {
                            if (oldVersion === 0) {
                                database.createObjectStore('tasks');
                                database.createObjectStore('logs');
                                database.createObjectStore('logs-stopped');
                                database.createObjectStore('orders');
                            }
                            if (oldVersion === 1) {
                                database.createObjectStore('orders');
                            }
                        }
                    })
                        .then(function (value) { return (_this.idb = value); })];
            });
        });
    };
    IdbService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IdbService_Factory() { return new IdbService(); }, token: IdbService, providedIn: "root" });
    return IdbService;
}());
export { IdbService };
